
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/pages/[page]",
      function () {
        return require("private-next-pages/pages/[page].js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/pages/[page]"])
      });
    }
  